<template>
  <div v-if="flow.length > 0" class="pt-80px" :class="hasFlowTxt ? 'pb-146px' : 'pb-80px'">
    <div class="text-center pb-40px">
      <p class="fs32 font-600">{{ titleZH }}</p>
      <p class="fs22 c9">{{ titleEN }}</p>
    </div>

    <div class="flex justify-center">
      <div v-for="(v, i) in flow" :key="i" class="flex">
        <div>
          <div class="flex">
            <img class="h-33px" :src="`${ossUrl}/common/market_v2/home/grab-9.png`" />
            <span class="fs24">{{ i + 1 }}</span>
          </div>
          <p class="fs24 font-600">{{ v.title }}</p>
          <div v-if="v.txt && v.txt.length > 0" class="font-400 pt-10px">
            <p v-for="(t, ii) in v.txt" :key="ii">{{ t }}</p>
          </div>
        </div>
        <img v-if="i !== 2" class="w-82px h-18px" :class="{ 'mx-98px mt-28px': !v.txt, 'mx-40px mt-72px': v.txt }" :src="`${ossUrl}/common/market_v2/home/grab-10.png`" />
      </div>
    </div>
  </div>
</template>

<script>
import { ossUrl } from '@/utils/config.js'
/**
 * 使用流程
 */
export default {
  name: 'OperationFlow',
  props: {
    titleZH: String,
    titleEN: String,
    flow: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ossUrl
    }
  },
  computed: {
    hasFlowTxt() {
      return this.flow.every(v => !!v.txt)
    }
  }
}
</script>

<style lang="scss" scoped></style>
